(function () {
  'use strict';
  if (window.__raptorV3) return;
  var records = new Map();
  window.__raptorV3 = records;
  var clamp = function (n) { return Math.max(0, Math.min(1, n)); };
  function init(section) {
    if (records.has(section)) return;
    var controller = new AbortController(), signal = controller.signal, cleanups = [];
    records.set(section, function () { controller.abort(); cleanups.forEach(function (fn) { fn(); }); });
    var reduced = matchMedia('(prefers-reduced-motion: reduce)');
    var stepsShape = section.querySelector('.r2-story__orb--steps');
    var hero = document.querySelector('.raptor-hero');
    if (stepsShape && hero) {
      // Two clipped color surfaces use the same artwork and document coordinates.
      var continuation = stepsShape.cloneNode(true);
      continuation.classList.add('v3-hero-shape-continuation');
      continuation.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      hero.appendChild(continuation);
      hero.classList.add('v3-shared-steps-shape');
      function alignShape() {
        var shapeRect = stepsShape.getBoundingClientRect(), heroRect = hero.getBoundingClientRect();
        continuation.style.left = (shapeRect.left - heroRect.left) + 'px';
        continuation.style.top = (shapeRect.top - heroRect.top) + 'px';
        continuation.style.width = shapeRect.width + 'px';
        continuation.style.height = shapeRect.height + 'px';
      }
      var shapeObserver = new ResizeObserver(alignShape);
      shapeObserver.observe(hero); shapeObserver.observe(section);
      window.addEventListener('resize', alignShape, {signal:signal});
      alignShape();
      var sharedAnimations = [];
      function syncSharedMotion() {
        sharedAnimations.forEach(function (animation) { animation.cancel(); });
        sharedAnimations = [];
        if (reduced.matches) return;
        var start = document.timeline.currentTime;
        [stepsShape, continuation].forEach(function (surface) {
          var animation = surface.querySelector('svg').animate([
            {transform:'translate3d(-12px,10px,0) rotate(59.11deg)'},
            {transform:'translate3d(22px,-22px,0) rotate(70.11deg)'}
          ], {duration:15000,iterations:Infinity,direction:'alternate',easing:'ease-in-out'});
          animation.startTime = start;
          sharedAnimations.push(animation);
        });
      }
      reduced.addEventListener('change', syncSharedMotion, {signal:signal});
      syncSharedMotion();
      cleanups.push(function () {sharedAnimations.forEach(function (animation) {animation.cancel();}); shapeObserver.disconnect(); continuation.remove(); hero.classList.remove('v3-shared-steps-shape');});
    }
    var steps = section.querySelector('.r2-story__cards--steps');
    if (steps && 'IntersectionObserver' in window) {
      var entryObserver = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          steps.classList.add('v3-entered'); entryObserver.disconnect();
        }
      }, {threshold: .15});
      steps.classList.add('v3-reveal'); entryObserver.observe(steps);
      cleanups.push(function () { entryObserver.disconnect(); steps.classList.remove('v3-reveal', 'v3-entered'); });
    }
    var stage = section.querySelector('[data-feedback-v3]:not([data-featured-testimonials]), [data-feedback-v3][data-featured-carousel]');
    if (stage) {
      var controls = stage.querySelector('[data-feedback-controls]');
      var buttons = controls ? Array.from(controls.querySelectorAll('button')) : [];
      var track = document.createElement('div'), reviews = [], groupStart = 0, requestedIndex = null;
      var cloudWidth = 0, groupAnimations = [], groupChanging = false, groupGeneration = 0;
      var edgeGesture = null, edgeOrigin = null, suppressEdgeClick = false;
      var edges = buttons.map(function (button, index) {
        // Pointer shortcuts only: the visible arrow pair owns keyboard navigation.
        var edge = document.createElement('div');
        edge.className = 'pg-review-edge';
        edge.dataset.reviewEdge = index === 0 ? 'prev' : 'next';
        edge.setAttribute('aria-hidden', 'true');
        edge.hidden = true;
        stage.appendChild(edge);
        edge.addEventListener('pointerdown', function (event) {
          edgeGesture = null;
          if (edge.hidden || event.button !== 0 || event.isPrimary === false) return;
          edgeOrigin = {id:event.pointerId};
          edgeGesture = {edge:edge, id:event.pointerId, x:event.clientX, y:event.clientY, released:false};
        }, {signal:signal});
        edge.addEventListener('click', function (event) {
          var valid = edgeGesture && edgeGesture.edge === edge && edgeGesture.released;
          edgeGesture = null;
          if (!valid || edge.hidden || button.disabled || stage.hasAttribute('data-review-open')) return;
          event.stopPropagation();
          button.click();
        }, {signal:signal});
        return edge;
      });
      function cancelEdgeGesture() { edgeGesture = null; }
      function freshEdgeInput() { edgeGesture = null; edgeOrigin = null; suppressEdgeClick = false; }
      window.addEventListener('pointerdown', freshEdgeInput, {capture:true, signal:signal});
      window.addEventListener('keydown', freshEdgeInput, {capture:true, signal:signal});
      window.addEventListener('click', function (event) {
        // Chrome can retarget a canceled touch click to the card beneath the rail.
        // Consume only that gesture's trailing click; fresh input resets the guard.
        if (!suppressEdgeClick) return;
        suppressEdgeClick = false;
        // Nonpointer accessibility activation has no preceding pointer/key event.
        if (event.detail === 0) return;
        event.preventDefault(); event.stopImmediatePropagation();
      }, {capture:true, signal:signal});
      window.addEventListener('pointermove', function (event) {
        if (edgeGesture && (event.pointerId !== edgeGesture.id ||
            Math.abs(event.clientX - edgeGesture.x) > 8 || Math.abs(event.clientY - edgeGesture.y) > 8)) cancelEdgeGesture();
      }, {passive:true, signal:signal});
      window.addEventListener('pointerup', function (event) {
        if (!edgeOrigin || event.pointerId !== edgeOrigin.id) return;
        edgeOrigin = null;
        suppressEdgeClick = true;
        if (!edgeGesture) return;
        // Touch implicitly captures pointers: the event target can remain the rail
        // after the finger has physically left its narrow gutter.
        var bounds = edgeGesture.edge.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX >= bounds.right ||
            event.clientY < bounds.top || event.clientY >= bounds.bottom) { cancelEdgeGesture(); return; }
        if (event.target !== edgeGesture.edge || event.pointerId !== edgeGesture.id ||
            Math.abs(event.clientX - edgeGesture.x) > 8 || Math.abs(event.clientY - edgeGesture.y) > 8) cancelEdgeGesture();
        else { edgeGesture.released = true; suppressEdgeClick = false; }
      }, {signal:signal});
      window.addEventListener('pointercancel', function (event) {
        if (edgeOrigin && event.pointerId === edgeOrigin.id) { edgeOrigin = null; suppressEdgeClick = true; }
        cancelEdgeGesture();
      }, {signal:signal});
      window.addEventListener('scroll', function (event) {
        // Frames from our pending smooth scroll must not swallow the next tap.
        if (event.target !== track || requestedIndex === null) cancelEdgeGesture();
      }, {capture:true, passive:true, signal:signal});
      window.addEventListener('resize', cancelEdgeGesture, {signal:signal});
      stage.addEventListener('pg:review-toggle', function () { cancelEdgeGesture(); syncEdges(); }, {signal:signal});
      stage.addEventListener('pg:reviews-updated', cancelEdgeGesture, {signal:signal});
      function syncEdges() {
        edges.forEach(function (edge, index) {
          edge.hidden = window.innerWidth > 749 || controls.hidden || buttons[index].disabled || stage.hasAttribute('data-review-open');
        });
      }

      var autoTimer = null, autoInView = !window.IntersectionObserver;
      var autoHovered = false, autoFocused = false, autoPointerDown = false;
      function stopAutoAdvance() {
        window.clearTimeout(autoTimer); autoTimer = null;
      }
      function scheduleAutoAdvance() {
        stopAutoAdvance();
        if (!autoInView || document.hidden || reduced.matches || autoHovered || autoFocused || autoPointerDown ||
            groupChanging || stage.hasAttribute('data-review-open')) return;
        if (desktopClouds() ? reviews.length <= 3 : reviews.length < 2 || track.scrollWidth <= track.clientWidth + 1) return;
        autoTimer = window.setTimeout(function () {
          autoTimer = null;
          if (desktopClouds()) scrollReview(groupStart + 3 >= reviews.length ? 0 : groupStart + 3);
          else if (Math.abs(track.scrollLeft) >= track.scrollWidth - track.clientWidth - 1) scrollReview(0);
          else navigate(1);
          scheduleAutoAdvance();
        }, 6000);
      }
      var wasStatic = stage.classList.contains('v3-feedback-static');
      track.className = 'pg-review-track';
      track.setAttribute('data-review-track', '');
      track.tabIndex = 0;
      ['aria-label', 'aria-labelledby'].forEach(function (name) {
        if (stage.hasAttribute(name)) track.setAttribute(name, stage.getAttribute(name));
      });
      stage.insertBefore(track, controls);
      stage.classList.remove('v3-feedback-static');
      stage.classList.add('pg-review-carousel');
      function desktopClouds() {
        return section.classList.contains('r2-story--quotes') && track.clientWidth >= 1000;
      }
      function cancelGroupAnimation() {
        groupGeneration++;
        groupAnimations.forEach(function (animation) { animation.cancel(); });
        groupAnimations = []; groupChanging = false;
      }
      function measureCloudRows() {
        if (cloudWidth === track.clientWidth) return;
        cloudWidth = track.clientWidth;
        var heights = [0, 0];
        reviews.forEach(function (card) {
          var probe = card.cloneNode(true);
          probe.hidden = false; probe.setAttribute('aria-hidden', 'true');
          probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;margin:0';
          track.appendChild(probe);
          [5, 8].forEach(function (columns, row) {
            probe.style.width = (cloudWidth * columns / 12) + 'px';
            heights[row] = Math.max(heights[row], probe.offsetHeight);
          });
          probe.remove();
        });
        track.style.gridTemplateRows = (heights[0] + 12) + 'px ' + heights[1] + 'px';
      }
      function layoutReviews() {
        var clouds = desktopClouds();
        stage.classList.toggle('pg-review-clouds', clouds);
        if (clouds) measureCloudRows();
        else { cloudWidth = 0; track.style.gridTemplateRows = ''; }
        reviews.forEach(function (card, index) {
          card.hidden = clouds && (index < groupStart || index >= groupStart + 3);
          if (clouds && !card.hidden) card.dataset.reviewSlot = String(index - groupStart);
          else card.removeAttribute('data-review-slot');
        });
        syncControls();
        scheduleAutoAdvance();
      }
      function syncControls() {
        if (desktopClouds()) {
          if (controls) controls.hidden = reviews.length <= 3;
          if (buttons[0]) buttons[0].disabled = groupChanging || groupStart === 0;
          if (buttons[1]) buttons[1].disabled = groupChanging || groupStart + 3 >= reviews.length;
          syncEdges();
          return;
        }
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var position = requestedIndex === null ? Math.abs(track.scrollLeft) :
          Math.min(max, reviews[requestedIndex].offsetLeft - reviews[0].offsetLeft);
        if (controls) controls.hidden = reviews.length < 2 || max <= 1;
        if (buttons[0]) buttons[0].disabled = position <= 1;
        if (buttons[1]) buttons[1].disabled = position >= max - 1;
        syncEdges();
      }
      function populateReviews() {
        cancelGroupAnimation(); cloudWidth = 0; requestedIndex = null;
        reviews = Array.from(stage.querySelectorAll('[data-feedback]'));
        reviews.forEach(function (card) {
          card.hidden = false;
          card.classList.add('pg-review-slide');
          track.appendChild(card);
        });
        track.scrollLeft = 0;
        groupStart = 0;
        layoutReviews();
      }
      function changeGroup(start) {
        if (groupChanging || start === groupStart) return;
        var outgoing = reviews.filter(function (card) { return !card.hidden; });
        if (reduced.matches || !outgoing.length || !outgoing[0].animate) {
          groupStart = start; layoutReviews(); return;
        }
        groupChanging = true; syncControls();
        var generation = ++groupGeneration;
        var incoming = reviews.slice(start, start + 3), remaining = Math.max(outgoing.length, incoming.length);
        var order = Array.from({length:remaining}, function (_, index) { return index; });
        for (var index = order.length - 1; index > 0; index--) {
          var swap = Math.floor(Math.random() * (index + 1));
          var saved = order[index]; order[index] = order[swap]; order[swap] = saved;
        }
        var delays = [];
        order.forEach(function (slot, rank) { delays[slot] = rank * 90; });
        function finishSlot() {
          if (generation !== groupGeneration) return;
          remaining--;
          if (!remaining) {
            groupStart = start;
            cancelGroupAnimation(); layoutReviews();
          }
        }
        function enterSlot(slot) {
          if (generation !== groupGeneration) return;
          var oldCard = outgoing[slot], newCard = incoming[slot];
          if (oldCard) { oldCard.hidden = true; oldCard.removeAttribute('data-review-slot'); }
          if (!newCard) { finishSlot(); return; }
          newCard.hidden = false; newCard.dataset.reviewSlot = String(slot);
          var arrival = newCard.animate([
            {opacity:0,transform:'translateX(48px)'},
            {opacity:1,transform:'translateX(0)'}
          ], {duration:460,delay:oldCard ? 0 : delays[slot],easing:'cubic-bezier(.22,1,.36,1)',fill:'both'});
          groupAnimations.push(arrival);
          arrival.onfinish = function () {
            arrival.cancel();
            groupAnimations = groupAnimations.filter(function (animation) { return animation !== arrival; });
            finishSlot();
          };
        }
        groupAnimations = [];
        for (var slot = 0; slot < remaining; slot++) {
          if (!outgoing[slot]) { enterSlot(slot); continue; }
          var departure = outgoing[slot].animate([
            {opacity:1,transform:'translateX(0)'},
            {opacity:0,transform:'translateX(-36px)'}
          ], {duration:300,delay:delays[slot],easing:'ease-in',fill:'both'});
          groupAnimations.push(departure);
          departure.onfinish = (function (animation, slotIndex) {
            return function () {
              animation.cancel();
              groupAnimations = groupAnimations.filter(function (active) { return active !== animation; });
              enterSlot(slotIndex);
            };
          }(departure, slot));
        }
      }
      function scrollReview(index) {
        if (!reviews.length || stage.hasAttribute('data-review-open')) return;
        index = Math.max(0, Math.min(reviews.length - 1, index));
        if (desktopClouds()) {
          changeGroup(Math.floor(index / 3) * 3);
          return;
        }
        requestedIndex = index;
        var left = reviews[index].offsetLeft - reviews[0].offsetLeft;
        if (track.scrollTo) track.scrollTo({left:left, behavior:reduced.matches ? 'instant' : 'smooth'});
        else track.scrollLeft = left;
        syncControls();
      }
      function navigate(direction) {
        if (!reviews.length) return;
        if (desktopClouds()) { scrollReview(groupStart + direction * 3); return; }
        if (requestedIndex !== null) { scrollReview(requestedIndex + direction); return; }
        var nearest = 0;
        reviews.forEach(function (card, index) {
          if (Math.abs(card.offsetLeft - reviews[0].offsetLeft - track.scrollLeft) <
              Math.abs(reviews[nearest].offsetLeft - reviews[0].offsetLeft - track.scrollLeft)) nearest = index;
        });
        scrollReview(nearest + direction);
      }
      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          navigate(index === 0 ? -1 : 1);
          scheduleAutoAdvance();
        }, {signal:signal});
      });
      track.addEventListener('scroll', function () {
        if (requestedIndex === null) cancelEdgeGesture();
        if (requestedIndex !== null) {
          var target = Math.min(track.scrollWidth - track.clientWidth, reviews[requestedIndex].offsetLeft - reviews[0].offsetLeft);
          if (Math.abs(Math.abs(track.scrollLeft) - target) <= 1) requestedIndex = null;
        }
        syncControls(); scheduleAutoAdvance();
      }, {passive:true, signal:signal});
      function manualScroll() { cancelEdgeGesture(); requestedIndex = null; syncControls(); }
      track.addEventListener('pointerdown', manualScroll, {passive:true, signal:signal});
      track.addEventListener('wheel', manualScroll, {passive:true, signal:signal});
      track.addEventListener('keydown', function (event) {
        if (event.target !== track || event.ctrlKey || event.metaKey || event.altKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) { manualScroll(); return; }
        event.preventDefault();
        if (event.key === 'Home') scrollReview(0);
        else if (event.key === 'End') scrollReview(reviews.length - 1);
        else {
          var rtl = getComputedStyle(track).direction === 'rtl';
          navigate((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
      }, {signal:signal});
      stage.addEventListener('mouseenter', function () { autoHovered = true; stopAutoAdvance(); }, {signal:signal});
      stage.addEventListener('mouseleave', function () { autoHovered = false; scheduleAutoAdvance(); }, {signal:signal});
      stage.addEventListener('focusin', function () { autoFocused = true; stopAutoAdvance(); }, {signal:signal});
      stage.addEventListener('focusout', function (event) {
        autoFocused = stage.contains(event.relatedTarget); scheduleAutoAdvance();
      }, {signal:signal});
      stage.addEventListener('pointerdown', function () { autoPointerDown = true; stopAutoAdvance(); }, {signal:signal});
      function releaseReviewPointer() { autoPointerDown = false; scheduleAutoAdvance(); }
      window.addEventListener('pointerup', releaseReviewPointer, {signal:signal});
      window.addEventListener('pointercancel', releaseReviewPointer, {signal:signal});
      document.addEventListener('visibilitychange', scheduleAutoAdvance, {signal:signal});
      reduced.addEventListener('change', scheduleAutoAdvance, {signal:signal});
      var autoObserver = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
        autoInView = entries[0].isIntersecting; scheduleAutoAdvance();
      }, {threshold:0}) : null;
      if (autoObserver) autoObserver.observe(stage);
      stage.addEventListener('pg:reviews-updated', populateReviews, {signal:signal});
      stage.addEventListener('pg:review-toggle', function () {
        scheduleAutoAdvance();
        groupAnimations.forEach(function (animation) {
          if (stage.hasAttribute('data-review-open')) animation.pause();
          else animation.play();
        });
      }, {signal:signal});
      stage.addEventListener('pg:reviews-ready', function () { cloudWidth = 0; layoutReviews(); }, {signal:signal});
      window.addEventListener('resize', function () { requestedIndex = null; cancelGroupAnimation(); layoutReviews(); }, {signal:signal});
      section.addEventListener('shopify:block:select', function (event) {
        var index = reviews.findIndex(function (card) { return card === event.target || card.contains(event.target); });
        if (index >= 0) scrollReview(index);
      }, {signal:signal});
      if (document.fonts) document.fonts.ready.then(function () { if (records.has(section)) { cloudWidth = 0; layoutReviews(); } });
      populateReviews();
      cleanups.push(function () {
        stopAutoAdvance();
        freshEdgeInput(); edges.forEach(function (edge) { edge.remove(); });
        if (autoObserver) autoObserver.disconnect();
        cancelGroupAnimation();
        reviews.forEach(function (card) { card.hidden = false; card.removeAttribute('data-review-slot'); card.classList.remove('pg-review-slide'); stage.insertBefore(card, track); });
        stage.classList.remove('pg-review-clouds');
        track.remove(); stage.classList.remove('pg-review-carousel');
        stage.classList.toggle('v3-feedback-static', wasStatic);
        buttons.forEach(function (button) { button.disabled = false; });
        if (controls) controls.hidden = true;
      });
    }


  }
  function scan(root) { if (root.matches && root.matches('[data-raptor-section]')) init(root); root.querySelectorAll('[data-raptor-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () {scan(document);},{once:true}); else scan(document);
  document.addEventListener('shopify:section:load',function (e) {scan(e.target);});
  document.addEventListener('shopify:section:unload',function (e) { Array.from(records.keys()).forEach(function (s) {if(s===e.target || e.target.contains(s)){var cleanup=records.get(s); records.delete(s); cleanup();}}); });
}());
